import { FormGroup } from '@angular/forms';
import { ImportConfigurationFileFormType } from './configuration-form-file-form-type';
import { ImportConfigurationDTO, FilterDTO, ImportFileFormat, ImportType } from 'src/app/base/models/models.swagger.generated';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { TabComponent, SelectingEventArgs, TabModule } from '@syncfusion/ej2-angular-navigations';
import { Component, ViewChild, OnInit, AfterViewChecked, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import * as pages from './../../../../../core/routing/page-names';
import { TranslateModule } from '@ngx-translate/core';
import { FileFilterComponent } from './file-filter/file-filter.component';
import { FileEdifactComponent } from './file-edifact/file-edifact.component';
import { FileColumnBasedComponent } from './file-column-based/file-column-based.component';
import { FileGeneralComponent } from './file-general/file-general.component';
import { FileAcodisComponent } from './file-acodis/file-acodis.component';
import { ImportConfigurationAcodisFormType } from '../configuration-form-acodis/configuration-form-acodis-form-type';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-configuration-form-file',
    templateUrl: './configuration-form-file.component.html',
    styleUrls: ['./configuration-form-file.component.scss'],
    imports: [TabModule, FileGeneralComponent, FileColumnBasedComponent, FileEdifactComponent, FileFilterComponent, TranslateModule, FileAcodisComponent]
})
export class ConfigurationFormFileComponent implements OnInit, OnDestroy, AfterViewChecked {

  @ViewChild('tabObj')
  public tabObj: TabComponent;

  public animation: object = {
    previous: { effect: "", duration: 0, easing: "" },
    next: { effect: "", duration: 0, easing: "" }
  };

  public get configuration(): ImportConfigurationDTO {
    return this.formsCoordinationService.configuration;
  }

  public get fileForm(): FormGroup<ImportConfigurationFileFormType> {
    return this.formsCoordinationService.configurationFormFile;
  }

  public get acodisForm(): FormGroup<ImportConfigurationAcodisFormType> {
    return this.formsCoordinationService.configurationFormAcodis;
  }

  public get fieldAssignmentsInvalid(): boolean {
    return !this.formsCoordinationService.configurationFormFile.controls.fieldAssignments.valid && (!this.formsCoordinationService.configurationFormFile.pristine || !this.formsCoordinationService.isInitialFormValid);
  }

  public get generalTabInvalid(): boolean {
    if( this.formsCoordinationService.configurationFormGeneral.controls.importType.value == ImportType.Parashift) {
      return false;
    }
    else{
    return (!this.formsCoordinationService.configurationFormFile.controls.fileFormat.valid ||
      !this.formsCoordinationService.configurationFormFile.controls.isTitleContainedInFile.valid ||
      !this.formsCoordinationService.configurationFormFile.controls.decimalSeperator.valid ||
      !this.formsCoordinationService.configurationFormFile.controls.seperatorCharacter.valid ||
      !this.formsCoordinationService.configurationFormFile.controls.textFormat.valid ||
      !this.formsCoordinationService.configurationFormFile.controls.fileNameSearchPattern.valid) &&
      (!this.formsCoordinationService.configurationFormFile.pristine || !this.formsCoordinationService.isInitialFormValid);
    }
  }

  private subscriptions = new Subscription();

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
    private location: Location,
    private cdr: ChangeDetectorRef
  ) { }

  public ngOnInit() {
    this.subscriptions.add(
      this.fileForm.controls.fileFormat.valueChanges.subscribe(() => {
        this.setTabVisibility();
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  public select(event: SelectingEventArgs): void {
    if (event.isSwiped) {
      event.cancel = true;
      return;
    }
    this.setUrlRoute(event.selectingIndex);
  }

  public tabGroupCreated() {
    if (this.configuration) {
      this.getUrlRoute();
    }
    this.setTabVisibility();
  }

  public getUrlRoute() {
    var url = this.location.path().split("/");
    var pageRoute = url[url.length - 1];

    switch (pageRoute) {
      case pages.configurationFileGeneralPageName:
        this.tabObj.select(this.TAB_GENERAL);
        break;
      case pages.configurationFileColumnBasedPageName:
        this.tabObj.select(this.TAB_COLUMN_BASED);
        break;
      case pages.configurationFileEdifactPageName:
        this.tabObj.select(this.TAB_EDIFACT);
        break;
      case pages.configurationFileAcodisPageName:
        this.tabObj.select(this.TAB_ACODIS);
        break;
      case pages.configurationFileFilterPageName:
        this.tabObj.select(this.TAB_FILTER);
        break;
      default:
        this.tabObj.select(this.TAB_GENERAL);
        break;
    }
  }

  public onFilterUpdated(filterDto: FilterDTO) {
    this.fileForm.controls.filter.setValue(filterDto);
  }

  private setUrlRoute(index: number) {
    if (this.location.path().endsWith(pages.configurationFilePageName)) {
      this.location.replaceState(this.location.path() + "/" + pages.configurationFileGeneralPageName);
      return;
    }

    const base = this.location.path() + '/../';
    switch (index) {
      case 0:
        this.location.replaceState(base + pages.configurationFileGeneralPageName);
        break;
      case 1:
        this.location.replaceState(base + pages.configurationFileColumnBasedPageName);
        break;
      case 2:
        this.location.replaceState(base + pages.configurationFileEdifactPageName);
        break;
      case 3:
        this.location.replaceState(base + pages.configurationFileAcodisPageName);
        break;
      case 4:
        this.location.replaceState(base + pages.configurationFileFilterPageName);
        break;
    }
  }

  private setTabVisibility() {
    this.tabObj?.hideTab(this.TAB_COLUMN_BASED, this.fileForm.controls.fileFormat.value == ImportFileFormat.PDF || this.fileForm.controls.fileFormat.value == ImportFileFormat.EDIFACT || this.formsCoordinationService.configurationFormGeneral.controls.importType.value == ImportType.Parashift);
    this.tabObj?.hideTab(this.TAB_EDIFACT, this.fileForm.controls.fileFormat.value != ImportFileFormat.EDIFACT);
    this.tabObj?.hideTab(this.TAB_ACODIS, this.fileForm.controls.fileFormat.value != ImportFileFormat.PDF || this.formsCoordinationService.configurationFormGeneral.controls.importType.value == ImportType.Parashift);
  }

  private TAB_GENERAL = 0;
  private TAB_COLUMN_BASED = 1;
  private TAB_EDIFACT = 2;
  private TAB_ACODIS = 3;
  private TAB_FILTER = 4;

}
